var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuggestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC794"
    },
    d: "M29.392,54.999c11.246,0.156,17.52-4.381,21.008-9.189c3.603-4.966,4.764-11.283,3.647-17.323 C50.004,6.641,29.392,6.826,29.392,6.826S8.781,6.641,4.738,28.488c-1.118,6.04,0.044,12.356,3.647,17.323 C11.872,50.617,18.146,55.155,29.392,54.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M18,38.998c0,6.075,4.925,11,11,11s11-4.925,11-11H18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M38,44.998H20c-0.552,0-1-0.447-1-1s0.448-1,1-1h18c0.552,0,1,0.447,1,1S38.552,44.998,38,44.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M25,49.998c-0.552,0-1-0.447-1-1v-10c0-0.553,0.448-1,1-1s1,0.447,1,1v10 C26,49.551,25.552,49.998,25,49.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M33,49.998c-0.552,0-1-0.447-1-1v-10c0-0.553,0.448-1,1-1s1,0.447,1,1v10 C34,49.551,33.552,49.998,33,49.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M4.499,30.124c-0.453-0.429-0.985-0.687-1.559-0.687C1.316,29.437,0,31.418,0,33.862 c0,2.443,1.316,4.424,2.939,4.424c0.687,0,1.311-0.37,1.811-0.964C4.297,34.969,4.218,32.537,4.499,30.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M57.823,26.298c-0.563-2.377-2.3-3.999-3.879-3.622c-0.491,0.117-0.898,0.43-1.225,0.855 c0.538,1.515,0.994,3.154,1.328,4.957c0.155,0.837,0.261,1.679,0.328,2.522c0.52,0.284,1.072,0.402,1.608,0.274 C57.562,30.907,58.386,28.675,57.823,26.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M13.9,16.998c-0.256,0-0.512-0.098-0.707-0.293l-5-5c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l5,5c0.391,0.391,0.391,1.023,0,1.414C14.412,16.901,14.156,16.998,13.9,16.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M16.901,13.998c-0.367,0-0.72-0.202-0.896-0.553l-3-6c-0.247-0.494-0.047-1.095,0.447-1.342 c0.495-0.246,1.095-0.047,1.342,0.447l3,6c0.247,0.494,0.047,1.095-0.447,1.342C17.204,13.964,17.051,13.998,16.901,13.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M20.9,11.998c-0.419,0-0.809-0.265-0.949-0.684l-2-6C17.777,4.79,18.06,4.224,18.584,4.05 c0.525-0.177,1.09,0.108,1.265,0.632l2,6c0.175,0.524-0.108,1.091-0.632,1.265C21.112,11.982,21.005,11.998,20.9,11.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M25.899,10.998c-0.48,0-0.904-0.347-0.985-0.836l-1-6c-0.091-0.544,0.277-1.06,0.822-1.15 c0.546-0.095,1.06,0.278,1.151,0.822l1,6c0.091,0.544-0.277,1.06-0.822,1.15C26.009,10.994,25.954,10.998,25.899,10.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M29.9,10.998c-0.552,0-1-0.447-1-1v-6c0-0.553,0.448-1,1-1s1,0.447,1,1v6 C30.9,10.551,30.453,10.998,29.9,10.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M33.9,10.998c-0.104,0-0.211-0.017-0.316-0.052c-0.524-0.174-0.807-0.74-0.632-1.265l2-6 c0.175-0.523,0.738-0.809,1.265-0.632c0.524,0.174,0.807,0.74,0.632,1.265l-2,6C34.709,10.734,34.319,10.998,33.9,10.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M37.9,11.998c-0.104,0-0.211-0.017-0.316-0.052c-0.524-0.174-0.807-0.74-0.632-1.265l2-6 c0.174-0.523,0.74-0.809,1.265-0.632c0.524,0.174,0.807,0.74,0.632,1.265l-2,6C38.709,11.734,38.319,11.998,37.9,11.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F62"
    },
    d: "M40.899,13.998c-0.15,0-0.303-0.034-0.446-0.105c-0.494-0.247-0.694-0.848-0.447-1.342l3-6 c0.248-0.494,0.846-0.693,1.342-0.447c0.494,0.247,0.694,0.848,0.447,1.342l-3,6C41.62,13.796,41.267,13.998,40.899,13.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M29,50.998c-6.617,0-12-5.383-12-12c0-0.553,0.448-1,1-1h22c0.552,0,1,0.447,1,1 C41,45.615,35.617,50.998,29,50.998z M19.05,39.998c0.503,5.046,4.774,9,9.95,9s9.447-3.954,9.95-9H19.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M28.39,21.856c0,3.217-1.092,10.195-14.564,8.739C8.228,29.99,8,25.074,8,21.856l0,0 C14.317,18.246,22.073,18.246,28.39,21.856L28.39,21.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464F5D"
    },
    d: "M17.237,31.79c-1.102,0-2.275-0.066-3.519-0.201C7,30.863,7,24.551,7,21.856v-0.58l0.504-0.288 c6.594-3.768,14.787-3.768,21.382,0l0.504,0.288v0.58c0,3.04-0.961,5.444-2.856,7.146C24.467,30.857,21.348,31.79,17.237,31.79z  M9.004,22.444c0.051,3.313,0.631,6.692,4.929,7.157c5.297,0.576,9.085-0.13,11.265-2.088c1.337-1.2,2.068-2.905,2.177-5.074 C21.658,19.4,14.722,19.401,9.004,22.444z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M31.61,21.856c0,3.217,1.092,10.195,14.564,8.739C51.772,29.99,52,25.074,52,21.856l0,0 C45.683,18.246,37.927,18.246,31.61,21.856L31.61,21.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464F5D"
    },
    d: "M42.763,31.79c-4.112,0-7.23-0.934-9.297-2.789c-1.895-1.701-2.856-4.105-2.856-7.146v-0.58 l0.504-0.288c6.595-3.768,14.788-3.768,21.382,0L53,21.276v0.58c0,2.695,0,9.007-6.718,9.733 C45.039,31.724,43.865,31.79,42.763,31.79z M32.625,22.439c0.109,2.169,0.84,3.874,2.177,5.074 c2.181,1.958,5.972,2.661,11.265,2.088c4.297-0.465,4.877-3.845,4.929-7.157C45.278,19.401,38.342,19.4,32.625,22.439z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.39,
    y: 21.207,
    style: {
      fill: "#464F5D"
    },
    width: 3.22,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M12.292,26.426c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l3.22-3.219 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414L13,26.133C12.804,26.328,12.548,26.426,12.292,26.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M16.585,28.572c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l5.366-5.365 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-5.366,5.365C17.097,28.475,16.841,28.572,16.585,28.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M35.902,26.426c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l3.22-3.219 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-3.22,3.219C36.414,26.328,36.158,26.426,35.902,26.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M40.195,28.572c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l5.366-5.365 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-5.366,5.365C40.707,28.475,40.451,28.572,40.195,28.572z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestions);
export default __webpack_public_path__ + "static/media/suggestions.541cd335c236d43f9542bff970f650e6.svg";
export { ForwardRef as ReactComponent };